import { session } from '@/stores/session'

/**
 * Le champ `context` d'une notification donne les identifiants des objets
 * concernés : on en déduit l'écran à ouvrir (dans la limite des permissions).
 */
export function notificationTarget(notification) {
  const ctx = notification.context || {}
  const type = String(notification.type || '')
  if (ctx.report_id && session.can('reports.view')) return '/reports'
  if (ctx.payment_id && session.can('payments.view')) return { path: '/payments', query: { status: 'pending' } }
  if (type.startsWith('maintenance') && session.can('maintenance_records.view')) return '/maintenance'
  if (ctx.driver_id && session.can('drivers.view')) return `/drivers/${ctx.driver_id}`
  if (ctx.vehicle_id && session.can('vehicles.view')) return `/vehicles/${ctx.vehicle_id}`
  return '/notifications'
}
